var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverTune = function SvgDiscoverTune(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "discover-tune_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.667v-2h3v-4h2v4h3v2h-8Zm3 12v-10h2v10h-2Zm-10 0v-4H3v-2h8v2H8v4H6Zm0-8v-10h2v10H6Z",
    fill: "currentColor"
  })));
};
export { SvgDiscoverTune as ReactComponent };